export class EmptyCryptoKeyError extends Error {
    constructor(message) {
        super(message || 'Llave de encriptación vacía');
        this.name = 'EmptyCryptoKeyError';
    }
}
//# sourceMappingURL=empty_crypto_key_error.js.map